@layer ch-tabular-grid {
  ch-tabular-grid-action-refresh[disabled] {
    pointer-events: none;
  }
}
